import { Outlet } from 'react-router-dom'
import styled from '@emotion/styled'

const Container = styled('div')(() => ({
  padding: `40px 20px`,
}))

export const MainLayout = () => (
  <Container>
    <Outlet />
  </Container>
)
